import React, { useState } from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import SAEChart from '../../Charts/SAEChart';
import { Col, Row } from 'react-bootstrap';
import { saeByIc, saeByIcQuads } from '../../../utilities/sae-utils';
export default function SAE({ institutionData }) {

    const sae = saeByIc.filter((ic) => {
        return ic.ic2025 == institutionData.post_meta.ic2025.value;
    }).pop();

    return (
        <Widget>
            <Row gap={5} gap-lg={0}>
                <Row gap={5} gap-lg={0}>
                    <Col>
                        <h3 style={{ maxWidth: '1000px' }}>Student Access and Earnings: {institutionData.post_meta.ic2025.label} Classification</h3>
                    </Col>
                </Row>
                <SAEChart institutionData={institutionData} icWall={true} y2={sae.yLine} quadrant={saeByIcQuads[institutionData.post_meta.saec2025.value]} />

                <Col className='border-top pt-2 pt-lg-4 ps-lg-5 pe-lg-5 d-flex justify-content-between align-content-center'>
                    <div className='pt-2'>
                        This is just a summary. To see the full graph and interact with data for this school, visit the <a href="/saec/">Student Access and Earnings Visualization</a>.
                    </div>
                    <div className="pt-2 pt-lg-0 d-flex justify-content-end">
                        <a href="/saec">
                            <div className="circle-chev">
                                <img src="/wp-content/uploads/2023/01/arrow-right.svg" alt="" />
                            </div>
                        </a>
                    </div>
                </Col>
            </Row>
        </Widget>
    );
}
